import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {dataRegister} from "../../services/dataRegister";

class BoosterHeaderBrandingMobile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            temp_lang: null,
            language: false,
            dropwdown: false,
            market: null,
            temp_market: null,
            languages: []
        };
    };

    componentWillMount() {

    }

    componentDidMount(){
        this.setState({
            lang: this.props.lang,
            market: this.props.market,
            website: this.props.website,
            favicon: this.props.favicon
        }, () => {
            this._updateLang();
            this._updateLanguages();
        })
    }

    componentWillReceiveProps(nextProps, nextState){
        this.setState({
            lang: nextProps.lang,
            market: nextProps.market
        })
    }

    _updateLang(){
        this.setState({
            lang: this.state.lang
        });
    }

    _updateLanguages(){
        let languages = JSON.parse(salesChannelRegister.get('languages'));
        if(Array.isArray(languages)){
            this.setState({languages: languages});
        }
    }

    _openMenu() {
        this.setState({menu: true});
    }

    _closeMenu() {
        this.setState({menu: false});
    }

    _setLang(prop){
        this.setState({lang: prop, dropdown: false}, () => {
            this.props.history.push({
                pathname: '/' + this.state.market + '/' + prop
            });
            window.location.reload(false);
        });
    }

    _terms(value){
        window.open('https://legal.'+dataRegister.domain+"/" + this.state.market + "/" + this.state.lang + "/" + value + "/" + salesChannelRegister.get('name'), '_blank');
    }

    _renderLanguage(lang){
        try{
        let value = "";
        for(let i = 0; i < this.state.languages.length; i++){
            if(this.state.languages[i].code === lang){
                value = this.state.languages[i].names[this.state.lang];
            }
        }
        return value;
        }catch (e) {}
    }

    _renderText(item) {
        return langRegister.get("mobile-menu", item, this.state.lang);
    }

    renderFacebookPageLink(){
        try {

        }catch (e) {
            return undefined
        }
    }

    renderInstagramPageLink(){
        try {

        }catch (e) {
            return undefined
        }
    }

    render() {
        return (
            <div>
                <div className={
                    cx(Styles.menu,
                        {
                            [Styles.menuOpen]: this.state.menu,
                        })
                }>
                    <div className={Styles.menuInner}>
                        {
                            <a href={"https://"+this.props.website + "?utm_source=" + salesChannelRegister.get('name')} target={'_blank'}>
                                <img className={Styles.menuInnerLogo} src={this.props.favicon}/>
                            </a>
                        }
                        {
                            <img onClick={() => this._closeMenu()} className={Styles.menuInnerClose}
                                 src={require("../../assets/images/cross_icon.png")}/>
                        }
                        <div className={Styles.menuInnerOptions}>
                            <div className={Styles.dropdown}>
                                <select className={Styles.dropdownSelection} value={this.state.lang} onChange={(event) => this._setLang(event.target.value)}>
                                    {
                                        this.state.languages.map((item, key) => {
                                            return(
                                                <option key={key} value={item.code}>{item.names[this.state.lang]}</option>
                                            )
                                        })
                                    }
                                </select>
                                <div className={Styles.dropdownText}>
                                    {this._renderLanguage(this.state.lang)}
                                </div>
                                <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow_grey.svg")}/>
                            </div>

                            <div className={Styles.divider}/>

                            <div className={Styles.socialIcons}>

                            </div>
                            <div className={Styles.terms}>
                                <span onClick={() => this._terms("terms")}>{this._renderText("item_14")}</span> | <span onClick={() => this._terms("privacy")}>{this._renderText("item_15")}</span> | <span onClick={() => this._terms("acceptance")}>{this._renderText("item_16")}</span>
                            </div>
                            <div style={{width: "100%", height: "200px"}}/>
                        </div>
                    </div>
                </div>
                {
                    this.state.menu &&
                    <div className={Styles.overlay}/>
                }
            </div>
        );
    }
}

export default BoosterHeaderBrandingMobile;


// WEBPACK FOOTER //
// ./src/components/booster-header-branding-mobile/component.js